import { IState } from 'shared/store';

import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';
import { selectUser } from '../offerData';

export const ROSREESTR_DATA_VISIBILITY_EXPERIMENT = 'sub_desktop_hom_736_rosreest';

export const selectIsRosreestrDataVisible = (state: IState) => {
  const experiments = abUseExperimentsSelector(state);
  const user = selectUser(state);

  return (
    user?.isAuthenticated ||
    (!user?.isAuthenticated && isAbUseExperimentsActive(experiments, ROSREESTR_DATA_VISIBILITY_EXPERIMENT, 'A'))
  );
};
